import React, { SetStateAction } from 'react';

import CollapsibleFilters from '../../../../common/filterTable/components/Filters/CollapsibleFilters';
import { Filter } from '../../../../common/filterTable/types';
import { FilterFields, FilterFieldsKeys } from '../types/FilterFields';
import AssetNameMultiSelect from './filters/AssetNameMultiSelect';
import { MpTextField } from '../../../../components';
import { useTranslation } from '../../../../hooks';
import { translatePrefix } from '..';
import ChainTypeSelect from './filters/ChainTypeSelect';
import OperationTypeSingleSelection from './filters/OperationTypeSingleSelection';
import StatusSingleSelection from './filters/StatusSingleSelection';
import MerchantNameMultipleSelect from './filters/MerchantNameMultipleSelect';

interface FilterSectionProps {
  fields: FilterFields;
  setFields: React.Dispatch<SetStateAction<FilterFields>>;
  DateObj: any;
  isCollapse?: boolean;
}

const FilterSection = (props: FilterSectionProps) => {
  const { fields, setFields, DateObj, isCollapse } = props;

  const { tc, t } = useTranslation(translatePrefix);

  const updateField = (fieldName: string, value: any) => {
    setFields((fields) => {
      return {
        ...fields,
        [fieldName]: value,
      };
    });
  };

  const filters: Filter[] = [
    // Time-based filters (most commonly used)
    {
      labelKey: FilterFieldsKeys.CreatedDate,
      filter: <DateObj.CreatedDate.Picker type="date" />,
    },
    {
      labelKey: FilterFieldsKeys.LastModifiedDate,
      filter: <DateObj.LastModifiedDate.Picker type="date" />,
    },
    {
      labelKey: FilterFieldsKeys.Chain,
      filter: (
        <ChainTypeSelect
          value={fields[FilterFieldsKeys.Chain]}
          onChange={(chainUniqueId: string) => updateField(FilterFieldsKeys.Chain, chainUniqueId)}
          onClear={() => updateField(FilterFieldsKeys.Chain, '')}
        />
      ),
    },
    {
      labelKey: FilterFieldsKeys.OperationType,
      filter: (
        <OperationTypeSingleSelection
          value={fields[FilterFieldsKeys.OperationType]}
          onChange={(operationType: string) =>
            updateField(FilterFieldsKeys.OperationType, operationType)
          }
          onClear={() => updateField(FilterFieldsKeys.OperationType, '')}
        />
      ),
    },
    {
      labelKey: FilterFieldsKeys.Status,
      filter: (
        <StatusSingleSelection
          value={fields[FilterFieldsKeys.Status]}
          onChange={(status: string) => updateField(FilterFieldsKeys.Status, status)}
          onClear={() => updateField(FilterFieldsKeys.Status, '')}
        />
      ),
    },
    {
      labelKey: FilterFieldsKeys.MerchantIds,
      filter: (
        <MerchantNameMultipleSelect
          label={t('merchantNames')}
          value={fields[FilterFieldsKeys.MerchantIds]}
          onChange={(value) => updateField(FilterFieldsKeys.MerchantIds, value)}
          onClear={() => updateField(FilterFieldsKeys.MerchantIds, [])}
        />
      ),
    },

    {
      labelKey: FilterFieldsKeys.BatchID,
      filter: (
        <MpTextField
          label={tc('phSelection', { fieldName: t('batchId') })}
          value={fields[FilterFieldsKeys.BatchID]}
          onChange={(e) => updateField(FilterFieldsKeys.BatchID, e.target.value)}
        />
      ),
    },
  ];

  return (
    <>
      <CollapsibleFilters filters={filters} isCollapse={isCollapse} />
    </>
  );
};

export default FilterSection;
